<!-- <Loader :loading="loading" /> -->
 <div class="card shadow-sm border-0 rounded p-1">
  <!-- Proper Card Header -->
  <div class="card-header border-0 bg-transparent w-100 p-2">
    <div class="portal-members-header d-flex align-items-center justify-content-between gap-2">
      <h6 class="mb-0">Members</h6>
      <!-- search bar -->
      <input type="text"
        class="form-control text-xxs w-25 rounded-5 p-1 portal-members-search"
        placeholder="Search..."
        v-model="searchValue"
        @input="searchMember"
        />

      <!-- Filter Dropdown (kept variables, fixed structure) -->
      <div class="dropdown d-none">
        <a
          class="dropdown-toggle shadow btn btn-sm btn-primary rounded-3 text-decoration-none text-xxs"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <i class="bi bi-search fs-6"></i>
        </a>

        <div class="dropdown-menu p-3 shadow rounded-3">
          <p class="border-bottom text-xxs mb-2 pb-2">Search Filters</p>
          <ul class="list-unstyled mb-0">
            <li
              v-for="(filter, index) in filterOptions"
              :key="index"
              class="mb-2 d-flex align-items-center filter-item text-xxs"
              v-if="!appliedFilters.includes(filter)"
            >
              <a
                class="text-decoration-none text-dark"
                href="#"
                @click.prevent="selectFilter(filter)"
              >
                {{ filter.label }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="portal-members-actions px-2 d-flex align-items-center gap-2">
    <button type="button" class="btn btn-primary btn-sm fs-xsm ms-auto rounded" data-bs-toggle="modal"
      data-bs-target="#add_portal_member_modal" title="Add Member"
      @click="selectedUserIds = []"
      v-if="activeTab === 'members' && (user_details.user_role === 'admin'|| user_details?.user_role === 'organization admin' || portal_admin)">{{ add_members_label }}</button>
    <button type="button" class="btn btn-secondary btn-sm fs-xsm rounded" data-bs-toggle="modal"
      data-bs-target="#delete_portal_member_modal" title="Delete Member"
      @click="selectedUserIds = []"
      v-if="activeTab === 'members' && (user_details.user_role === 'admin' || user_details?.user_role === 'organization admin' || portal_admin)"> Remove Member(s)</button>
<button
  type="button"
  class="btn btn-primary btn-sm fs-xsm rounded d-xl-none"
  data-bs-toggle="offcanvas"
  data-bs-target="#positionsOffcanvas"
  aria-controls="positionsOffcanvas">
  Positions
</button>
  </div>


  <!-- Card Body -->
  <div>

    <!-- Filters Row: applied chips -->
    <div class="mb-2">
      <div class="d-flex flex-wrap align-items-center gap-2">
        <div
          v-for="(filter, index) in appliedFilters"
          :key="index"
          class="badge bg-light text-dark border rounded-pill px-3 py-2 d-flex align-items-center"
          @click="toggleSearchInput(filter)"
        >
          <span class="me-2 d-flex align-items-center gap-1">
            <span>{{ filter.label }}</span>
            <span v-if="searchQuery[index]" class="d-flex align-items-center">
              <span class="vr mx-3">|</span>
              <span>{{ searchQuery[index] }}</span>
            </span>
          </span>
          <i class="bx bx-x cursor-pointer" @click.stop="removeFilter(filter)"></i>
        </div>
      </div>
    </div>

    <!-- Filter Search Inputs (inline with spacing) -->
    <div>
      <div
        v-for="(filter, index) in appliedFilters"
        :key="index"
        class="mt-2"
      >
        <div
          v-if="activeSearchFilter === filter.key"
          class="d-flex align-items-center gap-2 mt-2"
        >
          <input
            v-model="searchQuery[filter.key]"
            type="text"
            class="form-control search-input text-xxs w-25 rounded-pill p-1 shadow"
            placeholder="Search..."
          />
          <button
            class="btn btn-sm btn-primary rounded-3 text-xxs"
            @click="applyFilter(filter)"
          >
            Apply
          </button>
        </div>
      </div>
    </div>

    <!-- Members Grid -->
      <div class="container-fluid p-1">
        <div class="row mt-3">
          <div v-if="filteredPortalUsers.length === 0 && is_loading" class="text-center py-5 w-100">
            <div class="spinner-border text-secondary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-2 mb-0 text-muted">Loading members...</p>
          </div>

          <div v-else>

            <div v-if="filteredPortalUsers.length > 0" class="row g-2 portal-members-grid">

          <div
            v-for="member in filteredPortalUsers.filter(user => (stagging_domain || user.role?.role !== 'admin' || user_details.user_role === 'organization admin'))"
            :key="member.id"
            class="col-6 col-sm-6 col-md-6 col-lg-3"
          >
         <div class="portal-member-card position-relative cursor-pointer rounded" @click="getProfileLink(member)">
  <!-- Three dots dropdown -->
  <div
    v-if="user_details.user_role === 'admin' || portal_admin"
    class="portal-member-menu position-absolute top-0 end-0 mt-2 me-2 dropstart"
    @click.stop
  >
    <a
      href="#" data-bs-toggle="dropdown"
      @click.stop="get_member_id(member.user_id)"
      aria-expanded="false"
    >
      <i class="bi bi-three-dots-vertical"></i>
    </a>

    <ul class="dropdown-menu">
      <li v-if="!adminUserIds.has(member.user_id)">
        <a
          class="dropdown-item text-xxs d-flex align-items-center gap-2"
          href="#"
          @click.stop="assign_portal_admin(member.user_id)"
        >
          <i class="bi bi-check"></i>
          Assign Portal Admin
        </a>
      </li>

      <li v-else>
        <a
          class="dropdown-item text-xxs d-flex align-items-center gap-2"
          href="#"
          @click.stop="unassign_portal_admin(member.user_id)"
        >
          <i class="bi bi-x-circle"></i>
          Unassign Portal Admin
        </a>
      </li>
    </ul>
  </div>

  <!-- Portal admin badge -->
  <span
    v-if="adminUserIds.has(member.user_id)"
    class="portal-member-admin-badge position-absolute text-xxs task-chip task-chip-tone-0">
    Portal Admin
  </span>

  <div v-if="get_member_profile_picture(member)" class="portal-member-avatar d-inline-flex justify-content-center align-items-center">
    <img
      :src="get_member_profile_picture(member)"
      alt="Profile picture"
    />
  </div>
  <i v-else class="bi bi-person-circle portal-member-icon text-dark pointer" aria-hidden="true"></i>

  <div class="portal-member-body position-relative">
    <h5 class="fw-bold text-dark fs-xsm mb-1">
      {{ member.first_name }} {{ member.last_name }}
    </h5>

    <div class="d-flex justify-content-center">
      <span v-if="member.positions?.length > 0" class="text-muted text-xxs align-items-center gap-1 px-2 py-1 mb-1 text-nowrap">
        {{ member.positions[0].portal_position.position.name }}
      </span>
    </div>
  </div>
</div>
          </div>

          </div>
          <!-- Empty State -->
          <div v-else class="text-center text-muted py-5">
            <i class="bx bx-user-x fs-1"></i>
            <p class="mb-0 mt-2">No members available</p>
          </div>

          </div>
        </div>
      </div>
  </div>
</div>

<teleport to="body">
<div class="modal fade" id="delete_portal_member_modal" tabindex="-1" aria-labelledby="portalMemberLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg"> <div class="modal-content">
      <div class="modal-header">
        <p class="modal-title text-xxs fw-500" id="portalMemberLabel">Remove Members</p>
        <button
          type="button"
          class="btn-close text-xxs fw-500"
          data-bs-dismiss="modal"
          aria-label="Close">
        </button>
      </div>
      <form @submit.prevent="deletePortalMembers">
        <div class="modal-body table-responsive">
          <table id="portalMemberTable" class="table table-striped text-xxs">
            <thead class="btn-primary text-white">
              <tr>
                <th scope="col">No:</th>
                <th scope="col">First Name</th>
                <th scope="col">Last Name</th>
                <th scope="col">Email</th>
                <th scope="col">Action<span class="ms-2"><input class="form-check-input" type="checkbox" id="delete_select_all_members" :checked="SelectAllMembers" @change.stop="toggleSelectAllMembers"/></span></th>
              </tr>
            </thead>
            <tbody class="text-black">
              <tr v-for="(user, index) in portal_users.filter(user => (user.positions && user.positions.length > 0) || (user.role?.role !== 'admin' && !adminUserIds.has(user.user_id)))" :key="user.id">
                <th scope="row">{{ index + 1 }}</th>
                <td>{{ user.first_name }}</td>
                <td>{{ user.last_name }}</td>
                <td>{{ user.email }}</td>
                <td class="text-center">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :id="'delete_portal_member_check_' + user.id"
                    :value="user.id"
                    @click.stop
                    v-model="selectedUserIds" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary text-xxs rounded" @click="deletePortalMembers">Remove Members</button>
        </div>
      </form>
    </div>
  </div>
</div>

</teleport>
<teleport to="body">
<div class="modal fade" id="add_portal_member_modal" tabindex="-1" aria-labelledby="portalMemberLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg"> <div class="modal-content">
      <div class="modal-header">
        <p class="modal-title text-xxs fw-500" id="portalMemberLabel">{{ is_invite_only_portal ? 'Invite Members' : 'Add Members' }}</p>
        <button
          type="button"
          class="btn-close text-xxs fw-500"
          data-bs-dismiss="modal"
          aria-label="Close">
        </button>
      </div>
      <form @submit.prevent="addPortalMembers">
        <div class="modal-body table-responsive">
          <table id="addPortalMemberTable" class="table table-striped text-xxs">
            <thead class="btn-primary text-white">
              <tr>
                <th scope="col">No:</th>
                <th scope="col">First Name</th>
                <th scope="col">Last Name</th>
                <th scope="col">Email</th>
                <th scope="col">Action <span class="ms-2"><input  class="form-check-input" type="checkbox" id="add_select_all_members" :checked="areAllSelected" @change.stop="toggleSelectAll"/></span></th>
              </tr>
            </thead>
            <tbody class="text-black">
              <tr v-for="(user, index) in users" :key="user.id">
                <th scope="row">{{ index + 1 }}</th>
                <td>{{ user.first_name }}</td>
                <td>{{ user.last_name }}</td>
                <td>{{ user.email }}</td>
                <td class="text-center">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :id="'add_portal_member_check_' + user.id"
                    :value="user.id"
                    @click.stop
                    v-model="selectedUserIds" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary text-xxs rounded" @click="addPortalMembers">{{ is_invite_only_portal ? 'Invite Members' : 'Add Members' }}</button>
        </div>
      </form>
    </div>
  </div>
</div>
</teleport>

<teleport to="body">
<div class="modal fade" id="assign_portal_member_modal" tabindex="-1" aria-labelledby="portalMemberLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <p class="modal-title text-xxs fw-500" id="portalMemberLabel">Assigned Roles</p>
        <button type="button" class="btn-close text-xxs fw-500" data-bs-dismiss="modal" aria-label="Close" ></button>
      </div>
      <div class="modal-body table-responsive">
        <!-- Search Box -->
        <div class="mb-3">
          <input
            type="text"
            v-model="searchQuery"
            class="form-control text-xxs"
            placeholder="Search members by name..."
          />
        </div>

        <!-- Table -->
        <div class="table-responsive">
          <table class="table table-striped text-xxs">
            <thead class="btn-primary text-white">
              <tr>
                <th scope="col">#</th>
                <th scope="col">First Name</th>
                <th scope="col">Last Name</th>
                <th scope="col">Email</th>
                <th scope="col">Assigned Role</th>
              </tr>
            </thead>
            <tbody class="text-black">
              <tr v-for="(user, index) in portal_users" :key="user.user_id">
                <th scope="row">{{ index + 1 }}</th>
                <td>{{ user.first_name }}</td>
                <td>{{ user.last_name }}</td>
                <td>{{ user.email }}</td>
                <td>

                  <span
                  v-for="(position,posIndex) in user.positions"
                  :key="position.position_id"
                  class="btn-primary badge bg-primary text-white me-1"
                >
                  {{ position.position_name }}
                  <button
                    type="button"
                    class="btn-close text-white ms-1"
                    aria-label="Remove"
                    @click="remove_position(user.id,position.position_id, posIndex,portals_roles[0]?.id)"
                  ></button>

                </span>
                <div v-if="portals_roles.length">
                  <div v-for="portal in portals_roles" :key="portal.id" class="mb-4">
                    <select
                      class="form-control text-xxs mt-2"
                      @change="assign_position_to_portal_user($event, portal.id,user.user_id )"
                    >
                    <option value="">Select a position</option>
                    <option
                      v-for="pos in available_positions(portal, user)"
                      :key="pos.id"
                      :value="pos.id"
                    >
                      {{ pos.name }}
                    </option>
                    </select>
                  </div>
                </div>
                <p v-else>No portals or positions found.</p>

                  <div v-for="user in portal_positions" :key="user.id">
                    <h3>{{ user.first_name }} {{ user.last_name }}</h3>

                    <span v-if="user.positions.length === 0" class="text-muted">
                      No roles assigned
                    </span>
                  </div>

                </td>
              </tr>
              <tr v-if="portal_users.length === 0">
                <td colspan="4" class="text-center text-muted">No users found.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
</teleport>
